/**
 * Formats the slot props, by adding "0" on one-digit values or just
 * returns them when having two-digit values.
 *
 * @see {@link https://fengyuanchen.github.io/vue-countdown/ Transform Slot Props} for further information.
 *
 * @param {object} props The slot props provide by the component.
 * @returns {object} The formatted props.
 */
function formatValuesLowerThanZero(props) {
  const formattedProps = {};

  Object.entries(props).forEach(([key, value]) => {
    formattedProps[key] = value < 10 ? `0${value}` : String(value);
  });

  return formattedProps;
}

export {
  formatValuesLowerThanZero
}
